import React, { useState } from 'react';
import api from '../api';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaClock, FaCheckCircle, FaUserTie, FaCalendarCheck } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    roofArea: '',
    electricityBill: '',
    message: ''
  });

  const [loading, setLoading] = useState(false); // 👈 Loading State

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // 👇 UPDATED SUBMIT LOGIC
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // API Call to your .NET Backend
      await api.post('/Contact/submit', formData);
      
      alert('Thank you! Our engineer will contact you within 24 hours.');
      
      // Clear Form
      setFormData({
        name: '', email: '', phone: '', location: '', roofArea: '', electricityBill: '', message: ''
      });

    } catch (err) {
      console.error(err);
      alert('Something went wrong. Please check your connection or WhatsApp us directly.');
    } finally {
      setLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Corporate Office - Patna",
      details: ["Road No. 15E, Rajeev Nagar", "Patna, Bihar - 800024"],
      color: "#00D084"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Branch Office - Ranchi",
      details: ["1st Floor, Tigga Complex", "Harmu Bypass, Ranchi, Jharkhand - 834002"],
      color: "#1B3F6E"
    },
    {
      icon: <FaPhone />,
      title: "Phone Numbers",
      details: ["+91-9031654981", "+91-9031654984", "+91-9031654985"],
      color: "#FF6B35"
    },
    {
      icon: <FaEnvelope />,
      title: "Email Address",
      details: ["askus@rengie.in", "www.rengie.in"],
      color: "#FFC107"
    }
  ];

  const serviceAreas = [
    { state: "Bihar", cities: ["Patna", "Gaya", "Chhapra", "Siwan"] },
    { state: "Jharkhand", cities: ["Ranchi", "Hazaribagh", "Ramgarh", "Dhanbad", "Jamshedpur"] }
  ];

  return (
    <section className="contact-section py-5 bg-light" id="contact">
      <div className="container">
        
        {/* Section Header */}
        <div className="text-center mb-5">
          <span className="badge bg-success mb-3 px-3 py-2">Contact Us</span>
          <h2 className="display-5 fw-bold text-dark mb-3">Get Your Free Site Survey Today</h2>
          <p className="lead text-muted">Our solar engineers are ready to help you go solar</p>
        </div>

        <div className="row g-4 mb-5">
          {/* Contact Form */}
          <div className="col-lg-7">
            <div className="card border-0 shadow-lg h-100">
              <div className="card-body p-5">
                <h3 className="fw-bold mb-4" style={{ color: '#1B3F6E' }}>
                  <i className="bi bi-clipboard-check text-success me-2"></i>
                  Request Free Site Survey
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    
                    {/* Name */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Full Name *</label>
                      <input type="text" className="form-control form-control-lg" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required />
                    </div>

                    {/* Phone */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Phone Number *</label>
                      <input type="tel" className="form-control form-control-lg" name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" required />
                    </div>

                    {/* Email */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Email Address</label>
                      <input type="email" className="form-control form-control-lg" name="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" />
                    </div>

                    {/* Location */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Location *</label>
                      <select className="form-select form-select-lg" name="location" value={formData.location} onChange={handleChange} required>
                        <option value="">Select City</option>
                        <optgroup label="Bihar">
                          <option value="Patna">Patna</option>
                          <option value="Gaya">Gaya</option>
                          <option value="Chhapra">Chhapra</option>
                          <option value="Siwan">Siwan</option>
                        </optgroup>
                        <optgroup label="Jharkhand">
                          <option value="Ranchi">Ranchi</option>
                          <option value="Hazaribagh">Hazaribagh</option>
                          <option value="Ramgarh">Ramgarh</option>
                          <option value="Dhanbad">Dhanbad</option>
                          <option value="Jamshedpur">Jamshedpur</option>
                        </optgroup>
                      </select>
                    </div>

                    {/* Roof Area */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Available Roof Area (sq.ft.)</label>
                      <input type="number" className="form-control form-control-lg" name="roofArea" value={formData.roofArea} onChange={handleChange} placeholder="e.g., 500" />
                    </div>

                    {/* Electricity Bill */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Monthly Electricity Bill (₹)</label>
                      <input type="number" className="form-control form-control-lg" name="electricityBill" value={formData.electricityBill} onChange={handleChange} placeholder="e.g., 3000" />
                    </div>

                    {/* Message */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">Additional Requirements</label>
                      <textarea className="form-control" name="message" value={formData.message} onChange={handleChange} rows="4" placeholder="Tell us about your requirements..."></textarea>
                    </div>

                    {/* Submit Button (Updated with Loading State) */}
                    <div className="col-12">
                      <button 
                        type="submit" 
                        className="btn btn-success btn-lg w-100 rounded-pill" 
                        style={{ background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)', border: 'none' }}
                        disabled={loading}
                      >
                        {loading ? (
                          <span>Sending Request... <span className="spinner-border spinner-border-sm ms-2"></span></span>
                        ) : (
                          <><i className="bi bi-send-fill me-2"></i> Submit Request</>
                        )}
                      </button>
                      <p className="text-muted text-center mt-3 small mb-0">
                        <i className="bi bi-shield-check text-success me-1"></i> Your information is secure and will not be shared
                      </p>
                    </div>

                  </div>
                </form>

                {/* ⬇️ Content Below Form (Kept Same) ⬇️ */}
                <div className="mt-5 pt-4 border-top">
                  <h5 className="fw-bold mb-4" style={{ color: '#1B3F6E' }}><FaCheckCircle className="text-success me-2" /> What Happens Next?</h5>
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)', color: '#ffffff', fontWeight: 'bold', fontSize: '1.2rem' }}>1</div>
                        <div><h6 className="fw-bold mb-1" style={{ color: '#1B3F6E' }}><FaUserTie className="text-success me-2" /> Engineer Contact</h6><p className="text-muted small mb-0">Our NIT/DTU trained solar engineer will call you within <strong>24 hours</strong> to understand your requirements</p></div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #1B3F6E 0%, #2E5C8A 100%)', color: '#ffffff', fontWeight: 'bold', fontSize: '1.2rem' }}>2</div>
                        <div><h6 className="fw-bold mb-1" style={{ color: '#1B3F6E' }}><FaCalendarCheck className="text-success me-2" /> Free Site Survey</h6><p className="text-muted small mb-0">Schedule a convenient time for our engineer to visit your site and assess roof space, shading & electrical infrastructure</p></div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C5A 100%)', color: '#ffffff', fontWeight: 'bold', fontSize: '1.2rem' }}>3</div>
                        <div><h6 className="fw-bold mb-1" style={{ color: '#1B3F6E' }}><i className="bi bi-file-earmark-text text-success me-2"></i> Custom Proposal</h6><p className="text-muted small mb-0">Receive detailed system design, cost breakdown, subsidy eligibility & ROI calculation within <strong>48 hours</strong></p></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Trust Indicators */}
                <div className="mt-4 p-4 rounded" style={{ background: 'linear-gradient(135deg, #E8F8F3 0%, #E3F2FD 100%)' }}>
                  <div className="row text-center g-3">
                    <div className="col-6"><div className="fw-bold" style={{ color: '#00D084', fontSize: '1.5rem' }}><i className="bi bi-clock-history me-2"></i>24 Hours</div><small className="text-muted">Response Time</small></div>
                    <div className="col-6"><div className="fw-bold" style={{ color: '#1B3F6E', fontSize: '1.5rem' }}><i className="bi bi-currency-rupee me-2"></i>100% Free</div><small className="text-muted">Site Survey</small></div>
                    <div className="col-6"><div className="fw-bold" style={{ color: '#FF6B35', fontSize: '1.5rem' }}><i className="bi bi-shield-check me-2"></i>No Hidden</div><small className="text-muted">Charges</small></div>
                    <div className="col-6"><div className="fw-bold" style={{ color: '#FFC107', fontSize: '1.5rem' }}><i className="bi bi-people me-2"></i>500+</div><small className="text-muted">Happy Customers</small></div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Right Side Content (Address/Maps/WhatsApp) - Keeping Static */}
          <div className="col-lg-5">
            <div className="mb-4">
              {contactInfo.map((info, index) => (
                <div className="card border-0 shadow-sm mb-3" key={index}>
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px', background: `linear-gradient(135deg, ${info.color} 0%, ${info.color}dd 100%)`, fontSize: '1.5rem', color: '#ffffff' }}>{info.icon}</div>
                      <div className="flex-grow-1 ms-3">
                        <h5 className="fw-bold mb-2" style={{ color: '#1B3F6E' }}>{info.title}</h5>
                        {info.details.map((detail, idx) => (<p className="text-muted mb-1 small" key={idx}>{detail}</p>))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Service Areas */}
            <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #1B3F6E 0%, #2E5C8A 100%)' }}>
              <div className="card-body p-4 text-white">
                <h5 className="fw-bold mb-3"><i className="bi bi-geo-alt-fill me-2" style={{ color: '#00D084' }}></i>Our Service Areas</h5>
                {serviceAreas.map((area, index) => (
                  <div className="mb-3" key={index}>
                    <h6 className="fw-semibold" style={{ color: '#00D084' }}>{area.state}</h6>
                    <p className="mb-0 small">{area.cities.join(' | ')}</p>
                  </div>
                ))}
                <div className="mt-4 pt-3 border-top border-white border-opacity-25">
                  <p className="mb-0 small"><FaClock className="me-2" style={{ color: '#00D084' }} /><strong>Working Hours:</strong> Mon - Sat: 9:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Maps Section (Kept as is) */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="card border-0 shadow-lg overflow-hidden">
              <div className="card-header bg-white p-4 border-bottom">
                <h3 className="fw-bold mb-2" style={{ color: '#1B3F6E' }}><i className="bi bi-geo-alt-fill text-success me-2"></i>Find Us on Map</h3>
                <p className="text-muted mb-0">Visit our offices in Patna or Ranchi for consultation</p>
              </div>
              <div className="card-body p-0">
                <div className="row g-0">
                  {/* Patna Map */}
                  <div className="col-md-6">
                    <div className="p-3 bg-light border-end"><h5 className="fw-bold mb-2" style={{ color: '#00D084' }}><FaMapMarkerAlt className="me-2" />Patna Office</h5><p className="text-muted small mb-3">Road No. 15E, Rajeev Nagar, Patna - 800024</p></div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14391.234567890!2d85.123456!3d25.600000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDM2JzAwLjAiTiA4NcKwMDcnMjQuNCJF!5e0!3m2!1sen!2sin!4v1234567890" width="100%" height="400" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="RENGIE Patna Office"></iframe>
                  </div>
                  {/* Ranchi Map */}
                  <div className="col-md-6">
                    <div className="p-3 bg-light"><h5 className="fw-bold mb-2" style={{ color: '#00D084' }}><FaMapMarkerAlt className="me-2" />Ranchi Office</h5><p className="text-muted small mb-3">Harmu Bypass, Ranchi, Jharkhand - 834002</p></div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14652.345678901!2d85.321654!3d23.344100!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDIwJzM4LjgiTiA4NcKwMTknMTguMCJF!5e0!3m2!1sen!2sin!4v1234567890" width="100%" height="400" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="RENGIE Ranchi Office"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp CTA */}
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="card border-0 shadow-lg" style={{ background: '#25D366' }}>
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-8 text-white">
                    <h4 className="fw-bold mb-2"><FaWhatsapp className="me-2" /> Prefer WhatsApp? Chat with us directly!</h4>
                    <p className="mb-0">Get instant response from our solar experts on WhatsApp</p>
                  </div>
                  <div className="col-md-4 text-md-end mt-3 mt-md-0">
                    <a href="https://wa.me/919031654981" target="_blank" rel="noopener noreferrer" className="btn btn-light btn-lg rounded-pill px-4">
                      <FaWhatsapp className="me-2" style={{ color: '#25D366' }} /> Chat Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Contact;